import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import lifecodeLogo from './Lifecode-Final-logo-white.png';
import './App.css';

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="logo-section">
          <div className="logo-text">
            <img src={lifecodeLogo} alt="Lifecode" className="logo-image" />
            <h2 style={{ color: '#2d3748', fontSize: '1.5rem', marginTop: '1rem', fontWeight: '600' }}>Nutrition Questionnaire</h2>
          </div>
        </div>

        <div className="start-section">
          <div className="start-instruction">
            Click "Start" to begin.
          </div>
          <button onClick={() => navigate('/form')} className="start-button">
            Start <ArrowRight size={20} />
          </button>
        </div>

      </div>
    </div>
  );
};

export default Welcome;
